/**
 * Polyfill Flags
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'polyfill-flags';
const log = debug(MODULE_NAME);

// Dependencies
import * as BrowserFeatures from './browser-features';

log('BrowserFeatures', BrowserFeatures);
//noinspection OverlyComplexBooleanExpressionJS
export const useDateFieldPolyFill =
	// Use the polyfill if...

	// There's no native date input
	!BrowserFeatures.inputtypesDates ||

	// Or there is a native date input, but it's not a touch device
	BrowserFeatures.hasDatesButNoTouch ||

	// Otherwise, don't use the polyfill.
	false;



// WEBPACK FOOTER //
// ./project/client/src/core/services/polyfill-flags.js